"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountDownStore = void 0;
var mobx_1 = require("mobx");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var website_1 = require("utils/website");
var admin_1 = require("../../../services/page/admin");
var app_1 = require("../../../services/page/app");
var CountDownStore = (function () {
    function CountDownStore(moduleId, state, timer) {
        var _this = this;
        this.moduleId = "";
        this.remainSec = 0;
        this.refreshModule = function () { return __awaiter(_this, void 0, void 0, function () {
            var result_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, app_1.GetFrontModules({
                                moduleId: [this.moduleId],
                                meta: this.meta
                            })];
                    case 1:
                        result_1 = _a.sent();
                        if (result_1 && result_1.mods && result_1.mods[this.moduleId]) {
                            mobx_1.runInAction("refresh countDown module", function () {
                                var countDownModule = result_1.mods[_this.moduleId];
                                var module = countDownModule.module;
                                _this.state = module.state;
                                _this.timer = module.timer;
                                _this.remainSec = parseInt(module.timer.time.left, 10);
                            });
                        }
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.moduleId = moduleId;
        this.state = state;
        this.timer = timer;
        this.meta = {
            catalog: isomorphismConstant_1.default.country,
            lang: isomorphismConstant_1.default.language,
            client: website_1.isPC() ? "web" : "mweb",
            priceSymbol: isomorphismConstant_1.default.currency
        };
        mobx_1.reaction(function () { return _this.state; }, function (state) {
            clearInterval(_this.intervalId);
            if (state !== admin_1.TActState.OnGoing && state !== admin_1.TActState.ComingSoon) {
                return;
            }
            _this.remainSec = parseInt(timer.time.left, 10);
            _this.intervalId = setInterval(function () {
                if (_this.remainSec === 0) {
                    clearInterval(_this.intervalId);
                    _this.refreshModule();
                    return;
                }
                mobx_1.runInAction("tick", function () {
                    _this.remainSec = _this.remainSec - 1;
                });
            }, 1000);
        }, { fireImmediately: true });
    }
    __decorate([
        mobx_1.observable
    ], CountDownStore.prototype, "state", void 0);
    __decorate([
        mobx_1.observable
    ], CountDownStore.prototype, "timer", void 0);
    __decorate([
        mobx_1.observable
    ], CountDownStore.prototype, "remainSec", void 0);
    __decorate([
        mobx_1.action
    ], CountDownStore.prototype, "refreshModule", void 0);
    return CountDownStore;
}());
exports.CountDownStore = CountDownStore;
